function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M91.9,453.6c-3.5-1.6-5.8-5.2-5.8-9.1V368h-18C30.6,368,0,337.2,0,299.5V104c0-37.8,30.6-68.5,68.1-68.5h353.8 c37.6,0,68.1,30.7,68.1,68.5v195.5c0,37.8-30.6,68.5-68.1,68.5h-220l-99.3,84.2c-1.8,1.6-4.1,2.4-6.4,2.4 C94.7,454.5,93.3,454.2,91.9,453.6z M68.1,55.5c-26.6,0-48.2,21.8-48.2,48.5v195.5c0,26.7,21.6,48.5,48.2,48.5h28 c5.5,0,9.9,4.5,9.9,10v65l85.7-72.7c1.8-1.5,4.1-2.4,6.4-2.4h223.7c26.6,0,48.2-21.8,48.2-48.5V104c0-26.7-21.6-48.5-48.2-48.5 C421.9,55.5,68.1,55.5,68.1,55.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.9,137.5c0-5.5,4.5-10,9.9-10h320.3c5.5,0,9.9,4.5,9.9,10s-4.5,10-9.9,10H84.8C79.3,147.5,74.9,143,74.9,137.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.9,201.5c0-5.5,4.5-10,9.9-10h320.3c5.5,0,9.9,4.5,9.9,10s-4.5,10-9.9,10H84.8C79.3,211.5,74.9,207,74.9,201.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M74.9,265.5c0-5.5,4.5-10,9.9-10h320.3c5.5,0,9.9,4.5,9.9,10s-4.5,10-9.9,10H84.8C79.3,275.5,74.9,271.1,74.9,265.5z"
})));

var SvgReviewIcon = function SvgReviewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review-icon.5adbf72e.svg";
export { ForwardRef as ReactComponent };